import { render, staticRenderFns } from "./help.vue?vue&type=template&id=7f7252a1&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=7f7252a1&prod&lang=css"
import style1 from "./help.vue?vue&type=style&index=1&id=7f7252a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7252a1",
  null
  
)

export default component.exports